import moment from "moment";

const isMomentCome = (date) => {
    return 0 > moment(date).diff(moment(), 'day', true);
};

export default isMomentCome;
